<template>
  <b-overlay :show="loading" opacity="0.8">
    <validation-observer ref="newUserForm" #default="{invalid}">
      <b-form ref="form" @submit.prevent="onUpdateUser">
        <div style="height: 700px; border-bottom: solid lightgray 2px;">
          <b-row class="">
            <b-col cols="11">
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="UserIcon"
                  size="19"
                />
                <h4 class="mb-0 ml-50">
                  Personal Information
                </h4>
              </div>
            </b-col>
          </b-row>
  
          <!-- Media -->
          <div class="my-3 d-flex align-content-center w-100 justify-content-center">
            <div style="position: relative;">
              <b-avatar 
                ref="previewEl" 
                size="8rem" 
                variant="light-success" 
                :src="avatarPath"
                :text="avatarText(`${getValueFromSource(formData, 'full_name')}`)" 
              />
  
              <b-button 
                variant="primary" 
                class="btn-icon rounded-circle" 
                style="position: absolute; right: -10px; bottom: 5px;"
                @click="$refs.avatar.$el.childNodes[0].click()"
              >
                <feather-icon icon="CameraIcon" />
              </b-button>
            </div>
  
            <b-form-file v-show="false" ref="avatar" accept="image/*" placeholder="" no-drop @input="onImageRenderer" />
          </div>
  
          <b-row>
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="First Name" rules="required">
                <b-form-group label-for="first_name">
                  <template #label>
                    <span>First Name<span style="color: tomato">*</span></span>
                  </template>
  
                  <b-form-input
                    id="first_name"
                    v-model="formData.first_name"
                    placeholder="First name"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
  
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Last Name" rules="required">
                <b-form-group label-for="last_name">
                  <template #label>
                    <span>Last Name<span style="color: tomato">*</span></span>
                  </template>
  
                  <b-form-input
                    id="last_name"
                    v-model="formData.last_name"
                    placeholder="Last name"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
  
          <b-row class="mt-2">
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Email Address" rules="required|email">
                <b-form-group label-for="email">
                  <template #label>
                    <span>Email Address<span style="color: tomato">*</span></span>
                  </template>
  
                  <b-form-input
                    id="email"
                    v-model="formData.email"
                    :disabled="true"
                    placeholder="Email address"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
  
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Phone Number" rules="required|length:10">
                <b-form-group label-for="phone">
                  <template #label>
                    <span>Phone Number<span style="color: tomato">*</span></span>
                  </template>
  
                  <b-form-input
                    id="phone"
                    v-model="formData.phone"
                    placeholder="Phone number"
                    :disabled="true"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
  
          <b-row class="mt-2">
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Date of Birth" rules="required">
                <b-form-group label-for="date_of_birth">
                  <template #label>
                    <span>Date of Birthz<span style="color: tomato">*</span></span>
                  </template>

                  <validation-provider
                    #default="{ errors }"
                    name="date_of_birth"
                    rules="required|length:10"
                  >
                    <b-input-group>
                      <cleave 
                        v-model="formData.date_of_birth"
                        :options="cleaveDateOptions"
                        class="form-control"
                        name="date of birth"
                        placeholder="YYYY-MM-DD"
                        :raw="false"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
  
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Gender" rules="required">
                <b-form-group label-for="gender">
                  <template #label>
                    <span>Gender<span style="color: tomato">*</span></span>
                  </template>
  
                  <b-form-select
                    id="gender"
                    v-model="formData.gender"
                    placeholder="Gender"
                    :disabled="disableForm"
                    :options="genderOptions"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
  
          <b-row class="mt-2">
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Home Address" rules="">
                <b-form-group label-for="home_address" label="Home Address">
                  <b-form-input
                    id="home_address"
                    v-model="formData.home_address"
                    placeholder="Home address"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
  
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Work Phone" rules="length:10">
                <b-form-group label-for="work_phone" label="Work Phone">
                  <b-form-input
                    id="work_phone"
                    v-model="formData.work_phone"
                    placeholder="Work phone"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Insurance Name" rules="">
                <b-form-group label-for="insurance_name">
                  <template #label>
                    <span>Insurance Name</span>
                  </template>
  
                  <b-form-input
                    id="insurance_name"
                    v-model="formData.insurance_name"
                    placeholder="Insurance name"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
  
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Policy Number" rules="">
                <b-form-group label-for="policy_number">
                  <template #label>
                    <span>Policy Number</span>
                  </template>
  
                  <b-form-input
                    id="policy_number"
                    v-model="formData.policy_number"
                    placeholder="Policy number"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />
  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Region" rules="required">
                <b-form-group label-for="region">
                  <template #label>
                    <span>Region<span style="color: tomato">*</span></span>
                  </template>

                  <b-form-select
                    id="region"
                    v-model="formData.region"
                    placeholder="Region"
                    :disabled="disableForm"
                    :options="regionOptions"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider #default="validationContext" name="Location" rules="required">
                <b-form-group label-for="location">
                  <template #label>
                    <span>Location<span style="color: tomato">*</span></span>
                  </template>

                  <b-form-input
                    id="location"
                    v-model="formData.location"
                    placeholder="Location"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </div>

        <b-button
         class="float-right mt-2"
         style="width: 200px"
         variant="primary"
         block
         type="submit"
         :disabled="invalid || disableForm || loading"
       >
         Update
       </b-button>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BForm, BFormInput, BMedia, BAvatar,
  BFormFile, BFormDatepicker, BBadge,
  BOverlay, BAlert, BLink, BRow, BCol,
  BCard, BCardBody, BButton, BFormGroup, 
  BInputGroup, BInputGroupPrepend, BDropdown,
  BDropdownItem, BFormSelect, BFormInvalidFeedback
} from "bootstrap-vue"

import { get, cloneDeep } from 'lodash'
import { required, email } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import Cleave from 'vue-cleave-component';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    BOverlay,
    BAlert,
    BLink,
    BRow,
    BCol,
    BCard, 
    BCardBody, 
    BButton,
    BFormGroup, 
    BForm, 
    BFormInput,
    BMedia, 
    BAvatar,
    BFormFile,
    BFormDatepicker,
    BBadge,
    BInputGroup,
    BDropdown,
    BFormSelect,
    BDropdownItem,
    BInputGroupPrepend,
    BFormInvalidFeedback,
    Cleave,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  directives: {},
  props: {
    patientData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data(){
    return {
      loading: false,

      formData: null,
      permissionOptions: [],
      regionOptions: [],

      avatarPath: "",
      updatedImage: null,

      genderOptions: [
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' },
      ],

      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: '-',
        datePattern: ['Y', 'm', 'd'],
        blocks: [4, 2, 2],
      },

      required,
      email
    }
  },
  computed: {
    hasBasicUpdatePermission(){
      return this.can('patients:CanUpdate');
    },
    disableForm(){
      return !this.can('patients:CanUpdate');
    },
  },
  watch: {
    patientData: {
      handler() {
        this.avatarPath = this.getValueFromSource(this.patientData, 'avatar.path', '');
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.formData = cloneDeep(this.patientData);
    this.fetchGeoData()
  },
  methods: {
    async fetchGeoData(){
      try {
        this.loading = true;
        this.errorMessage = "";

        const query = {
          geo_id: 2300660
        }
        
        const response = await this.useJwt().mainService.geoData.list(query);
        const data = get(response, 'data.data');

        this.regionOptions = data.map((reg) => ({
          value: reg.name,
          text: reg.name,
        }))
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async onUpdateUser() {
      try {
        this.loading = true;

        const formData = new FormData();

        formData.append("first_name", this.formData.first_name);
        formData.append("last_name", this.formData.last_name);
        formData.append("email", this.formData.email);
        formData.append("phone", this.formData.phone);
        formData.append("date_of_birth", this.formData.date_of_birth);

        formData.append("gender", this.formData.gender);
        formData.append("work_phone", this.formData.work_phone);
        formData.append("home_address", this.formData.home_address);

        formData.append("insurance_name", this.formData.insurance_name);
        formData.append("policy_number", this.formData.policy_number);
        formData.append("region", this.formData.region);
        formData.append("location", this.formData.location);


        if (this.updatedImage) {
          formData.append("avatar", this.updatedImage);
        }

        await this.useJwt().mainService.patients.update(this.formData.id, formData);
        this.$emit('refresh')

        if (this.updatedImage) {
          this.updatedImage = null;
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Patient profile updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            variant: 'danger',
            text: error_message,
            icon: 'AlertTriangleIcon',
          },
        });
      } finally {
        this.loading = false
      }
    },
    onImageRenderer(file) {
      const reader = new FileReader()

      reader.addEventListener(
          'load',
          () => {
            this.avatarPath = reader.result
            this.updatedImage = file;
          },
          false,
      )

      if (file) {
        reader.readAsDataURL(file)
      }
    },
  }
}
</script>
